import supabase from "supabaseClient";

interface question {
  receiver: string;
  question: string;
  user: string;
}

export class AxiosWidgetQuestion {
  public async getQuestion(user: string) {
    const { data, error } = await (supabase as any)
      .from("ProfileQuestion")
      .select("*")
      .eq("Receiver", user);

    if (error) {
      console.error("Error fetching question:", error.message);
      return { error: error.message };
    }

    return { data };
  }

  async createQuestion(question: { receiver: string; question: string; user: string }) {
    const { data, error } = await (supabase as any)
      .from("ProfileQuestion")
      .insert({
        Receiver: question.receiver,
        Question: question.question,
        User: question.user,
      });

    if (error) {
      console.error("Error creating question:", error.message);
      return { error: error.message };
    }

    return { data };
  }
  async updateQuestion(question: { id: number; question: string }) {
    const { data, error } = await (supabase as any)
      .from("ProfileQuestion")
      .update({
        body: question.question,
      })
      .eq("id", question.id);

    if (error) {
      console.error("Error updating question:", error.message);

      throw error;
    }

    return data;
  }
}

export default new AxiosWidgetQuestion();
